<mat-toolbar class="content-header">
    <h1 class="page-title">
        <mat-icon>polyline</mat-icon>
        {{'workflows.title' | translate}}
        <!-- <app-help [link]="helpLink" class="helper-margin"></app-help> -->
    </h1>

    <span class="toolbar-spacer"></span>
    <!-- <span class="toggleWorkflows" *ngIf="iframeType; else nodalText">Compact</span>
    <ng-template #nodalText>
        <span class="toggleWorkflows">Nodal</span>
    </ng-template>
    <mat-slide-toggle *ngIf="role == 'admin' || role == 'dev' || role == 'userAdmin'" [(ngModel)]="iframeType"
        class="toggleWorkflows" (click)="toggleCompact()"></mat-slide-toggle> -->
</mat-toolbar>

<div class="workflows-container" *ngIf="!project || !project.archived">
    <iframe *ngIf="!iframeType" [src]="flowUrl | safe" height="100%" width="100%"></iframe>
</div>

<div class="workflow">
    <ng-container *ngIf="iframeType" class="page-container">
        <mat-tab-group [(selectedIndex)]="selectedTabIndex" class="tab-width"
            (selectedIndexChange)="onTabChange(selectedTabIndex)" [animationDuration]="200">
            <mat-tab *ngFor="let tab of tabs; let i = index" [label]="getTabLabel(tab.label)" class="flow-tab">
                <div class="new-page-content">
                    <form>
                        <div class="box-input">
                            <ng-container [ngTemplateOutlet]="inputList" [ngTemplateOutletContext]="{inputs: inputs}">
                            </ng-container>
                        </div>

                        <!-- list -->
                        <ng-template #inputList let-inputs="inputs">
                            <div *ngFor="let input of inputs" class="div-flow">
                                <ng-container [ngTemplateOutlet]="checkboxMasterForm"
                                    [ngTemplateOutletContext]="{config:input}">
                                </ng-container>

                                <div *ngFor="let option of input.options" [style.width]="option.widthDiv"
                                    [class.option-item]="input.enabled">
                                    <!-- <ng-container [ngTemplateOutlet]="selectForm"
                                        [ngTemplateOutletContext]="{config:option}"
                                        *ngIf="option.type=='select' && input.enabled">
                                    </ng-container>

                                    <ng-container [ngTemplateOutlet]="textForm"
                                        [ngTemplateOutletContext]="{config:option}"
                                        *ngIf="option.type=='text' && input.enabled">
                                    </ng-container>

                                    <ng-container [ngTemplateOutlet]="textareaForm"
                                        [ngTemplateOutletContext]="{config:option}"
                                        *ngIf="option.type=='textarea' && input.enabled">
                                    </ng-container>

                                    <ng-container [ngTemplateOutlet]="numberForm"
                                        [ngTemplateOutletContext]="{config:option}"
                                        *ngIf="option.type=='number' && input.enabled">
                                    </ng-container>

                                    <ng-container [ngTemplateOutlet]="dateForm"
                                        [ngTemplateOutletContext]="{config:option}"
                                        *ngIf="option.type=='datetime-local' && input.enabled">
                                    </ng-container>

                                    <ng-container [ngTemplateOutlet]="checkboxForm"
                                        [ngTemplateOutletContext]="{config:option}"
                                        *ngIf="option.type=='checkbox' && input.enabled">
                                    </ng-container>

                                    <ng-container [ngTemplateOutlet]="radioForm"
                                        [ngTemplateOutletContext]="{config:option}"
                                        *ngIf="option.type=='radio' && input.enabled">
                                    </ng-container>

                                    <ng-container [ngTemplateOutlet]="colorsForm"
                                        [ngTemplateOutletContext]="{config:option}"
                                        *ngIf="option.type=='colors' && input.enabled">
                                    </ng-container>

                                    <ng-container [ngTemplateOutlet]="colorForm"
                                        [ngTemplateOutletContext]="{config:option}"
                                        *ngIf="option.type=='color' && input.enabled">
                                    </ng-container> -->
                                </div>
                            </div>
                        </ng-template>

                        <!-- select -->
                        <ng-template #selectForm let-config="config">
                            <mat-form-field appearance="outline">
                                <mat-label>{{config.i18n | translate}}</mat-label>

                                <ng-container *ngIf="config.multiple">
                                    <mat-select matInput [(ngModel)]="config.value" [class]="config.customClass"
                                        [ngModelOptions]="{standalone: true}" (selectionChange)="config.update($event)"
                                        size="5" multiple>
                                        <mat-option [value]="opt.value" *ngFor="let opt of config.options">
                                            {{opt.name}}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>

                                <ng-container *ngIf="!config.multiple">
                                    <mat-select matInput [(ngModel)]="config.value"
                                        [ngModelOptions]="{standalone: true}" (selectionChange)="config.update($event)">
                                        <mat-option [value]="opt.value" *ngFor="let opt of config.options">
                                            {{opt.name}}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>
                            </mat-form-field>
                        </ng-template>

                        <!-- text -->
                        <ng-template #textForm let-config="config">
                            <mat-form-field appearance="outline" class="" [style.width]="config.width">
                                <mat-label>{{config.i18n | translate}}</mat-label>
                                <input matInput type="text" placeholder="0" [(ngModel)]="config.value"
                                    [style.height]="config.height" [ngModelOptions]="{standalone: true}"
                                    (change)="config.update($event)">
                            </mat-form-field>
                        </ng-template>

                        <!-- textarea -->
                        <ng-template #textareaForm let-config="config">
                            <mat-form-field appearance="outline" class="" [style.width]="config.width">
                                <mat-label>{{config.i18n | translate}}</mat-label>
                                <textarea matInput placeholder="0" [(ngModel)]="config.value"
                                    [style.height]="config.height" [ngModelOptions]="{standalone: true}"
                                    (change)="config.update($event)"></textarea>
                            </mat-form-field>
                        </ng-template>

                        <!-- number -->
                        <ng-template #numberForm let-config="config">
                            <mat-form-field appearance="outline" class="" [style.width]="config.width">
                                <mat-label>{{config.i18n | translate}}</mat-label>
                                <input matInput type="number" placeholder="0" [(ngModel)]="config.value"
                                    [ngModelOptions]="{standalone: true}"
                                    [min]="config.min !== undefined ? config.min : null"
                                    [max]="config.max !== undefined ? config.max : null"
                                    (change)="config.update($event)">
                            </mat-form-field>
                        </ng-template>

                        <!-- date -->
                        <ng-template #dateForm let-config="config">
                            <mat-form-field [style.width]="config.width">
                                <mat-label>{{config.i18n | translate}}</mat-label>
                                <input type="datetime" date-time auto-close="true" view="date" appearance="none"
                                    matInput [ngxMatDatetimePicker]="date" [value]="config.value"
                                    (dateChange)="config.update($event)">
                                <mat-datepicker-toggle appearance="none"></mat-datepicker-toggle>
                                <ngx-mat-datetime-picker #date>
                                    <ng-template>
                                        <span>OK</span>
                                    </ng-template>
                                </ngx-mat-datetime-picker>
                            </mat-form-field>
                        </ng-template>

                        <!-- checkbox -->
                        <ng-template #checkboxForm let-config="config">
                            <mat-checkbox [(ngModel)]="config.enabled" [ngModelOptions]="{standalone: true}"
                                (change)="config.update($event)" [style.width]="config.width || '250px'"
                                [class]="config.customClass">
                                {{config.i18n | translate}}</mat-checkbox>
                            <div class="group box-input" *ngIf="config.groupKey && config.value">
                                <ng-container [ngTemplateOutlet]="inputList">
                                </ng-container>
                            </div>
                        </ng-template>

                        <!-- checkbox master -->
                        <ng-template #checkboxMasterForm let-config="config">
                            <mat-checkbox [(ngModel)]="config.enabled" [ngModelOptions]="{standalone: true}"
                                (change)="config.update($event)" [style.width]="config.width || '250px'">
                                {{config.i18n | translate}}</mat-checkbox>
                            <div class="group box-input" *ngIf="config.groupKey && config.value">
                                <ng-container [ngTemplateOutlet]="inputList">
                                </ng-container>
                            </div>
                        </ng-template>

                    </form>

                    <div class="delete">
                        <button mat-raised-button color="warn" class="delete-button" (click)="removeTab(i)">
                            {{"workflows.delete_tab" | translate}}
                        </button>

                        <button mat-raised-button color="warn" class="save-button" (click)="saveTab(i)">
                            {{"workflows.save_tab" | translate}}
                        </button>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>

    </ng-container>

    <button *ngIf="iframeType == true" mat-icon-button color="primary" class="add-button" (click)="addTab()">
        <mat-icon>add</mat-icon>
    </button>
</div>

<div class="workflows-container" *ngIf="project && project.archived">
    <lib-no-data message="workflows.archived_project_title" description="workflows.archived_project_desc" icon="block">
    </lib-no-data>
</div>